// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609012016/js/" + chunkId + "." + {"44":"d693b4ec","225":"8e091c23","481":"9e8fab3b","486":"28a687c4","770":"c262399f"}[chunkId] + ".0.6896435186314979.chunk.js";
};